<template>
    <v-col class="pageStyle">
        <v-row>
            <v-col>
                <v-form ref="formRef" v-model="isValid" validate-on="input" @submit.prevent="onSubmit">

                    <div class="py-4">
                        <v-img class="mx-auto mb-10" max-width="228" :src="logo" />

                        <v-card class="mx-auto pa-12 pb-8" elevation="8" max-width="448" rounded="lg">
                            <div class="text-subtitle-1 text-medium-emphasis">Recuperare parolă</div>

                            <v-text-field v-model="identifier" density="compact"
                                placeholder="Introdu adresa de email sau username"
                                prepend-inner-icon="mdi-account-outline" variant="outlined" :readonly="loading"
                                :rules="[required, emailOrUser]" />

                            <v-btn block class="mb-8" color="blue" size="large" variant="tonal" type="submit"
                                :disabled="!isValid || loading" :loading="loading">
                                Trimite
                            </v-btn>

                            <div v-if="message" class="text-body-2 text-medium-emphasis">
                                {{ message }}
                            </div>
                            <div v-if="error" class="text-body-2 text-error">
                                {{ error }}
                            </div>
                        </v-card>
                    </div>
                </v-form>
            </v-col>
        </v-row>
    </v-col>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AppSettings from "@/settings/appSettings"
import ForgotPassword from '@/services/AUTH/ForgotPassword'

export default defineComponent({
    data() {
        return {
            logo: require("@/assets/auth/ElseLogo.png"),
            color: AppSettings.APP_Color,
            isValid: false as boolean,
            loading: false as boolean,
            identifier: '' as string,
            message: '' as string,
            error: '' as string,
        }
    },

    methods: {
        required(v) {
            return !!(v && String(v).trim()) || "Câmp obligatoriu";
        },
        emailOrUser(v) {
            const s = String(v ?? "").trim();
            if (!s) return true;
            const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
            const userOk = s.length >= 3;
            return (emailOk || userOk) || "Introduceți un email sau username valid (min. 3 caractere)";
        },

        async onSubmit() {
            const result = await (this.$refs.formRef as any)?.validate?.();
            if (!result?.valid) return;

            this.loading = true;
            this.message = "";
            this.error = "";

            try {
                await ForgotPassword.request(this.identifier.trim()); 
                this.message = "Dacă adresa există, vei primi un cod pe email în câteva minute.";
                setTimeout(() => {
                    this.$router.push({ path: "/validation-code", query: { id: this.identifier.trim() } });
                }, 1200);
            } catch (e: any) {
                console.error(e);
                this.message = "Dacă adresa există, vei primi un cod pe email în câteva minute.";
                this.$router.push({ path: "/validation-code", query: { id: this.identifier.trim() } });
            } finally {
                this.loading = false;
            }
        }

    },
})
</script>

<style>
.pageStyle {
    background: url("@/assets/auth/background.png") no-repeat center center;
}
</style>